export const TEST_ACCOUNT_EMAILS = new Set([
  'e2e-test@fabletable.ai',
  'e2e-admin-test@fabletable.ai',
]);

export const isTestAccountEmail = (email) =>
  typeof email === 'string' && TEST_ACCOUNT_EMAILS.has(email);

// Synchronously detect a cached test-account session before React Auth0 state
// hydrates. Lets MusicProvider seed its e2e gate at mount (frame 0) instead of
// racing the slug-swap effect against the async useEffect in MusicE2EGateBridge.
// Returns false on the first ever login (cache empty), which is fine — the
// bridge covers the post-callback transition.
export const isTestAccountCachedSync = () => {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const k = window.localStorage.key(i);
      if (!k || !k.startsWith('@@auth0spajs@@') || !k.endsWith('@@user@@')) continue;
      const raw = window.localStorage.getItem(k);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      const email = parsed?.decodedToken?.user?.email
        ?? parsed?.decodedToken?.claims?.email
        ?? parsed?.user?.email;
      if (isTestAccountEmail(email)) return true;
    }
  } catch {
    return false;
  }
  return false;
};
